import React from "react"
import styled from "styled-components"
import { normalizeExerciseId } from "../../util/strings"

const Heading = styled.div`
  & h3 {
    font-family: "Josefin Sans", sans-serif;
    font-size: clamp(20px, 3vw, 2rem);
    font-weight: 500;
    color: #333;
    text-transform: uppercase;
  }
`

const H3 = ({ children }) => {
  let text = "unknown heading"
  try {
    text = children.find((o) => typeof o === "string") || "unknown heading"
  } catch (e) {}
  const id = `heading-${normalizeExerciseId(text)}`
  return (
    <Heading>
      <h3 className="material-header" id={id}>
        {" "}
        {children}{" "}
      </h3>{" "}
    </Heading>
  )
}

export default H3
